import classNames from 'classnames';
import { CopyIcon } from '../icons';
import { copyTextToClipBoard } from '../utils';
import { Skeleton } from './Skeleton';

export interface StatisticItem {
  name: string;
  value: string | number;
  currency?: string;
  className?: string;
}

export interface BlockStatisticsWithCopyProps {
  items: StatisticItem[];
  withBorder?: boolean;
  withPaddingX?: boolean;
  isFetching?: boolean;
}

export const BlockStatisticsWithCopy = ({
  withBorder = false,
  withPaddingX = true,
  isFetching = false,
  items,
}: BlockStatisticsWithCopyProps) => {
  return (
    <div
      className={classNames(
        'w-full min-w-0 flex flex-wrap items-center justify-between md:grid md:grid-cols-2 md:items-stretch xl:grid-cols-3 2xl:grid-cols-5',
        { 'border border-gray-200 rounded-xl': withBorder },
      )}
    >
      {items?.map((item, i, all) => (
        <div
          key={i}
          className={classNames(
            'my-3 min-w-0 w-full flex gap-4 justify-between items-start font-[Inter] relative group/block border-gray-200',
            {
              'px-4': withPaddingX,
              'border-b md:border-b-0 md:border-r': i < all.length - 1,
              'md:border-r-0 xl:border-r': (i + 1) % 2 === 0 && i < all.length - 1,
              'xl:border-r-0 2xl:border-r': (i + 1) % 3 === 0 && i < all.length - 1,
              '2xl:border-r-0': (i + 1) % 5 === 0,
            },
          )}
        >
          <div className="flex min-w-0 flex-col gap-1 w-full">
            <div className="text-xs leading-5 text-[#737373]">{item.name}</div>
            {isFetching ? (
              <Skeleton width={'70%'} height={28} />
            ) : (
              <span
                className={classNames(
                  'flex items-baseline text-nowrap gap-1 md:min-w-0 md:flex-wrap md:whitespace-normal',
                  item.className,
                )}
              >
                <span className="text-xl md:min-w-0 md:max-w-full md:break-words md:text-lg 2xl:text-xl">
                  {item.value}
                </span>
                {item.currency && (
                  <span
                    className={classNames('shrink-0 text-xs', {
                      'text-gray-500': !item?.className?.includes('text-'),
                    })}
                  >
                    {item.currency}
                  </span>
                )}
              </span>
            )}
          </div>

          {!isFetching && (
            <div className="group-hover/block:block hidden absolute right-2 bottom-2">
              <span
                className="cursor-pointer hover:opacity-70"
                onClick={() =>
                  copyTextToClipBoard(String(item.value + (item.currency || '')), {
                    successMessage: 'Copied successfully',
                  })
                }
              >
                <img src={CopyIcon} alt="Copy" className="w-6 h-6 min-w-6 min-h-6 " />
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
